package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.css.ariaLabel
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.frontend.common.components.widgets.PromLogo
import meineglasfaser.frontend.common.components.widgets.PromLogoType
import meineglasfaser.frontend.common.components.widgets.ThemeToggle
import meineglasfaser.frontend.www.components.GlobalShopBasket
import meineglasfaser.frontend.www.components.layouts.CONTAINER_CLASS
import meineglasfaser.frontend.www.components.widgets.CustomerAccountPill
import meineglasfaser.frontend.www.pages.ProductAudiences
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
fun ShopHeader() {
    val ctx = rememberPageContext()
    Header(attrs = { classes(CONTAINER_CLASS) }) {
        IncidentBanner()
        Nav(attrs = {
            role("navigation")
            ariaLabel("Hauptnavigation")
        }) {
            Ul {
                Li {
                    Anchor(href = "/") {
                        PromLogo(PromLogoType.MAIN_COMPACT)
                    }
                }
                ProductAudiences.entries.forEach { audience ->
                    key(audience.id) {
                        Li {
                            Anchor(href = audience.href, attrs = {
                                if (ctx.route.path.startsWith(audience.href)) {
                                    classes("has-background-grey-lighter")
                                }
                            }) {
                                Text(audience.title)
                            }
                        }
                    }
                }
            }
            Ul {
                Li {
                    Anchor(href = "/basket", attrs = {
                        if (ctx.route.path == "/basket") {
                            classes("has-background-grey-lighter")
                        }
                    }) {
                        val basket by GlobalShopBasket.collectAsState()
                        Text("Warenkorb (${basket.products.size})")
                    }
                }
                Li {
                    ThemeToggle()
                }
                Li {
                    CustomerAccountPill()
                }
            }
        }
    }
}
